import { HeaderSkeleton, SkeletonRegion, TableSkeleton } from '@ems/ui/patterns/skeleton-blocks'

export function VouchersSkeleton() {
  return (
    <SkeletonRegion className="flex flex-col gap-6">
      <HeaderSkeleton title="w-24" description="w-56" actions={['h-9 w-32']} />
      <TableSkeleton
        columns={[
          { cell: 'mono', widths: ['w-20', 'w-24'] },
          { cell: 'text', widths: ['w-36', 'w-28', 'w-44'], primary: true },
          { cell: 'text', widths: ['w-12', 'w-16'], align: 'end' },
          { cell: 'mono', widths: ['w-12', 'w-16'] },
          { cell: 'mono', widths: ['w-32', 'w-28'] },
          { cell: 'mono', widths: ['w-24', 'w-20'], header: 'w-20' },
          { cell: 'badge', widths: ['w-16'] },
          { cell: 'icon', header: null, align: 'end', shrink: true },
        ]}
      />
    </SkeletonRegion>
  )
}
